import { render, staticRenderFns } from "./toLogin.vue?vue&type=template&id=18d9a45a&scoped=true&"
import script from "./toLogin.vue?vue&type=script&lang=js&"
export * from "./toLogin.vue?vue&type=script&lang=js&"
import style0 from "./toLogin.vue?vue&type=style&index=0&id=18d9a45a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d9a45a",
  null
  
)

export default component.exports